import React from "react";
import { SvgIcon, SvgIconProps } from "module/common/component/display";
export function ArrowUpIcon (props: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...props} data-testid="ArrowUpIcon" viewBox="0 0 24 24">
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
        </SvgIcon>
    )
}
        